import React, { useState, useEffect } from 'react';
import './InputField.css';

interface InputFieldProps {
  id?: string;
  label?: string;
  placeholder?: string;
  helper?: string;
  value?: string;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  hasError?: boolean;
  validationRegex?: RegExp;
  maxLength?: number;
  disabled?: boolean; // Added disabled prop
  isMH?: boolean;
}

const InputField: React.FC<InputFieldProps> = ({
  id,
  label,
  placeholder,
  helper,
  value,
  onChange,
  hasError,
  validationRegex,
  maxLength,
  disabled,
  isMH
}) => {
  const [isValid, setIsValid] = useState(true);
  useEffect(() => {
    if (validationRegex && value) {
      setIsValid(validationRegex.test(value));
    } else {
      setIsValid(true);
    }
  }, [value, validationRegex]);

  const combinedHasError = hasError || !isValid;

  const handleOnChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (maxLength && e.target.value.length > maxLength) {
      return;
    }
    if (onChange) {
      onChange(e);
    }
  };

  return (
    <div className="input-field" style={{width: label==''? '50%': '100%'}}>
      {label && <label>{label}{label !== 'GST Number' && <mark style={{ background: 'transparent', color: 'red' }}>*</mark>}</label>}
      <input
        type={placeholder?.toLowerCase() === 'pincode' ? "number" : "text"}
        placeholder={placeholder}
        value={value}
        onChange={handleOnChange}
        className={combinedHasError ? 'error-border' : ''}
        disabled={disabled} // Added disabled attribute
      />
      {isMH && <span className="mhspecific">
                Request ID as per Mahaparwana govt. site
              </span>}
      {helper && <p className="helper">{helper}</p>}
      {!isValid && (
        <p className="validation-error" style={{ color: 'red', fontSize: '0.8rem', marginTop: '0.25rem' }}>
          Invalid format.
        </p>
      )}
    </div>
  );
};

export default InputField;